import { html } from 'lit';

export const iconTrashCanCircle = html`
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12.5" cy="12" r="12" fill="currentColor" />
    <path
      d="M10.5879 6.76172C10.6953 6.52539 10.9316 6.375 11.1895 6.375H13.7891C14.0469 6.375 14.2832 6.52539 14.3906 6.76172L14.5625 7.0625H16.625C16.9902 7.0625 17.3125 7.38477 17.3125 7.75C17.3125 8.13672 16.9902 8.4375 16.625 8.4375H8.375C7.98828 8.4375 7.6875 8.13672 7.6875 7.75C7.6875 7.38477 7.98828 7.0625 8.375 7.0625H10.4375L10.5879 6.76172ZM8.35352 9.125H16.625V16C16.625 16.7734 16.002 17.375 15.25 17.375H9.72852C8.97656 17.375 8.35352 16.7734 8.35352 16V9.125ZM10.0723 10.8438V15.6562C10.0723 15.8496 10.2441 16 10.416 16C10.6094 16 10.7598 15.8496 10.7598 15.6562V10.8438C10.7598 10.6719 10.6094 10.5 10.416 10.5C10.2441 10.5 10.0723 10.6719 10.0723 10.8438ZM12.1348 10.8438V15.6562C12.1348 15.8496 12.3066 16 12.4785 16C12.6719 16 12.8438 15.8496 12.8438 15.6562V10.8438C12.8438 10.6719 12.6719 10.5 12.4785 10.5C12.3066 10.5 12.1348 10.6719 12.1348 10.8438ZM14.2188 10.8438V15.6562C14.2188 15.8496 14.3691 16 14.5625 16C14.7344 16 14.9062 15.8496 14.9062 15.6562V10.8438C14.9062 10.6719 14.7344 10.5 14.5625 10.5C14.3691 10.5 14.2188 10.6719 14.2188 10.8438Z"
      fill="white"
    />
  </svg>
`;
